import store from '@/store';

export default function hasFeature(name) {
  const features = store.getters['app/features'];
  return features.indexOf(name) !== -1;
}
